import axios from '@/config/axios';

const initiateState = () => {
  return {
    allAppNotifications: {},
    appNotificationErrors: {},
    markAllAsReadStatus: false,
    updateNotificationStatus: false,
  };
};

const state = initiateState();
const getters = {
  getAllAppNotifications: (state) => state.allAppNotifications,
  getAppNotificationErrors: (state) => state.appNotificationErrors,
  getMarkAllAsReadStatus: (state) => state.markAllAsReadStatus,
  getUpdateNotificationStatus: (state) => state.updateNotificationStatus,
};

const mutations = {
  setAllAppNotifications(state, data) {
    state.allAppNotifications = data;
  },
  setAppNotificationErrors(state, data) {
    state.appNotificationErrors = data;
  },
  setMarkAllAsReadStatus(state, data) {
    state.markAllAsReadStatus = data;
  },
  setUpdateNotificationStatus(state, data) {
    state.updateNotificationStatus = data;
  },
};

const actions = {
  fetchAllAppNotifications: async (context, params) => {
    try {
      context.commit('appNotifications/setAllAppNotifications', null, { root: true });
      let url = `app-notifications/fetchAllAppNotifications`;
      const response = await axios.get(url, { params });
      context.commit('appNotifications/setAllAppNotifications', response.data, {
        root: true,
      });
    } catch (error) {
      context.commit('appNotifications/setAllAppNotifications', null, { root: true });
      context.commit('appNotifications/setAppNotificationErrors', error, {
        root: true,
      });
    }
  },
  fetchUnreadCount: async (context) => {
    try {
      context.commit('appNotifications/setUnreadNotificationsCount', null, { root: true });
      const response = await axios.get('app-notifications/fetchUnreadNotificationsCount');
      context.commit('appNotifications/setUnreadNotificationsCount', response.data.data, {
        root: true,
      });
    } catch (error) {
      context.commit('appNotifications/setUnreadNotificationsCount', null, { root: true });
      context.commit('appNotifications/setAppNotificationErrors', error, {
        root: true,
      });
    }
  },
  markAllAsRead: async (context, params) => {
    try {
      context.commit('appNotifications/setMarkAllAsReadStatus', false, { root: true });
      const response = await axios.get(
        `app-notifications/markAllNotificationsAsRead?type=${params.type}`
      );
      context.commit('appNotifications/setMarkAllAsReadStatus', response.data.success, {
        root: true,
      });
    } catch (error) {
      context.commit('appNotifications/setMarkAllAsReadStatus', false, { root: true });
      context.commit('appNotifications/setAppNotificationErrors', error.data.message, {
        root: true,
      });
    }
  },
  updateDataById: async (context, params) => {
    try {
      context.commit('appNotifications/setUpdateNotificationStatus', false, { root: true });
      const response = await axios.post(`app-notifications/update_data/${params.id}`, params.data);
      context.commit('appNotifications/setUpdateNotificationStatus', response.data.success, {
        root: true,
      });
    } catch (error) {
      context.commit('appNotifications/setUpdateNotificationStatus', false, { root: true });
      context.commit('appNotifications/setUpdateNotificationStatus', error.data.message, {
        root: true,
      });
    }
  },
};
export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};
